<template>
  <div style="background: #fff; width: 100%">
    <HelpPop ref="HelpPop" :RMSSD="info.afterRMSSD"></HelpPop>
    <!-- 头部 -->
    <!-- <HeaderModel></HeaderModel> -->

    <div class="health-report-page">
      <!-- 顶部导航 -->
      <div class="top-nav">
        <div class="back-home" @click="goBack">
          <img
            class="back-icon"
            src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login3.png"
            alt=""
          />
          <span>返回首页</span>
        </div>
      </div>

      <div ref="cardRef" class="cardRef">
        <!-- 页面标题 -->
        <h1 class="page-title">您的健康状态快照</h1>
        <p class="disclaimer">
          受数据采集时环境光线、人体晃动或其他外部因素干扰，相应测量数据及分析解读可能存在偏差，仅供参考
        </p>

        <!-- 心脏健康得分卡片 -->
        <div class="score-card">
          <div class="score-label">心脏健康得分</div>
          <div class="score-value">
            <span class="score-number">{{ info.score }}</span>
            <span class="score-unit">分</span>
            <img
              class="info-icon"
              @click="$refs.HelpPop.open(1)"
              src="@/static/3-12Eff1.png"
              alt=""
            />
          </div>
          <div class="score-badge">
            <img class="star-icon" src="@/static/3-12Eff2.png" alt="" />
            <span>超越全球{{ info.afterHealthRatio  }}%用户</span>
          </div>
        </div>

        <!-- 详细指标对比 (新模块) -->
        <div class="comparison-card">
          <div class="comparison-header">
            <h3 class="comparison-title">
              <img
                src="@/static/3-12-duibi3.png"
                style="
                  width: 2rem;
                  height: 2rem;
                  margin-right: 0.5rem;
                  vertical-align: middle;
                "
                alt=""
              />
              详细指标对比
            </h3>
            <p class="comparison-subtitle">
              ta-VNS安睡仪 — 睡眠模式疗愈前后对比
            </p>
          </div>

          <div class="metric-list">
            <div
              v-for="(item, index) in metrics"
              :key="index"
              class="metric-row"
            >
              <div class="metric-info">
                <div class="metric-name">
                  {{ item.name }}
                  <img
                    class="info-icon-small"
                    @click="$refs.HelpPop.open(item.helpId)"
                    src="@/static/3-12Eff3.png"
                    alt=""
                  />
                </div>
                <div class="metric-trend" :class="item.trendClass">
                  <img
                    v-if="item.trendClass == 'good'"
                    class="trend-icon"
                    src="@/static/3-12-duibi1.png"
                    alt="->"
                  />
                  <img
                    v-else
                    class="trend-icon"
                    src="@/static/3-23LOG12931923.png"
                    alt="->"
                  />
                  <span>{{ item.trendText }}%</span>
                </div>
              </div>

              <div class="metric-values">
                <!-- 疗愈前 -->
                <div class="value-box before-box">
                  <div class="box-label">疗愈前</div>
                  <div class="box-value">{{ item.before }}</div>
                  <div class="box-unit">{{ item.unit }}</div>
                </div>

                <!-- 箭头 -->
                <img
                  class="arrow-icon"
                  src="@/static/3-12-duibi2.png"
                  alt="->"
                />
                <!-- 疗愈后 (图片中右侧文字虽写疗愈前，但逻辑应为疗愈后，此处修正为疗愈后) -->
                <div
                  :class="
                    item.trendClass == 'good'
                      ? 'value-box after-box'
                      : 'value-box after-box-no'
                  "
                >
                  <div class="box-label">疗愈后</div>
                  <div class="box-value">{{ item.after }}</div>
                  <div class="box-unit">{{ item.unit }}</div>
                </div>
              </div>

              <div class="line"></div>
            </div>
          </div>
        </div>

        <!-- AI智能分析报告 (新模块) -->
        <div class="ai-report-card">
          <h3 class="ai-title">AI智能分析报告</h3>
          <p class="ai-content" v-for="(item, index) in AIList" :key="index">
            {{ item
            }}<span v-if="aiSuggestion.result == 'good' && index == 0" v-html="text"></span>
          </p>
        </div>

        <!-- 个性化健康建议 -->
        <div class="advice-card">
          <h2 class="advice-title">个性化健康建议</h2>
          <p class="advice-disclaimer">
            本建议基于您的分值生成，仅用于日常健康管理参考，不具有医疗诊断、治疗或预防疾病的效力。若有明显不适，请务必及时就医。在使用本软件及相关硬件设备前，建议咨询专业医生。
          </p>
          <div class="advice-list">
            <div class="advice-item" v-for="(item, index) in 4">
              <img class="advice-icon" src="@/static/3-12Eff4.png" alt="" />
              <span>{{ list[listIndex][index] }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部按钮组 -->
      <div class="button-group">
        <button class="btn-download" @click="handleDownloadReport">
          <img class="download-icon" src="@/static/3-12Eff5.png" alt="" />
          <span>下载报告</span>
        </button>
        <button class="btn-recapture" @click="handleRecapture">
          <img class="refresh-icon" src="@/static/3-12Eff6.png" alt="" />
          <span>再次采集</span>
        </button>
      </div>
    </div>
    <!-- 页脚 -->
    <FooterModel></FooterModel>
  </div>
</template>

<script>
import { report } from "@/api/index";
import HelpPop from "@/components/HelpPop.vue";
import HeaderModel from "@/components/HeaderModel.vue";
import FooterModel from "@/components/FooterModel.vue";
import domtoimage from "dom-to-image-more";
import { saveAs } from "file-saver";

export default {
  name: "HealthReport",
  components: {
    HeaderModel,
    HelpPop,
    FooterModel,
  },
  data() {
    return {
      info: {},
      text: "",
      aiSuggestion: {},
      list: [
        [
          "建议继续保持当前健康的生活节奏，维持适度的日常运动。",
          "坚持使用 ta-VNS 安睡仪，结合不同身体状态，使用相应模式。",
          "建议每日进行 10 分钟正念冥想，提升副交感神经活性，保持身心放松。",
          "保持充足睡眠（建议 7-8 小时），规律作息有助于心脏功能的自我修复。",
        ],
        [
          "建议适当优化日常作息，避免过度劳累，可进行规律的有氧锻炼。",
          "坚持使用 ta-VNS 安睡仪，结合不同身体状态，使用相应模式。",
          "建议每日进行 10 分钟正念冥想，提升副交感神经活性，缓解日常压力。",
          "保持充足睡眠（建议 7-8 小时），规律作息有助于心脏功能的自我修复。",
        ],
        [
          "建议主动改善生活方式，减少熬夜与久坐，增加轻量化的日常活动。",
          "坚持使用 ta-VNS 安睡仪，结合不同身体状态，使用相应模式。",
          "建议每日进行 10 分钟正念冥想，提升副交感神经活性，辅助调节身心平衡。",
          "保持充足睡眠（建议 7-8 小时），规律作息有助于心脏功能的自我修复。",
        ],
        [
          "建议咨询专业医生，获取针对性的健康评估，并在指导下安排日常活动。",
          "坚持使用 ta-VNS 安睡仪，结合不同身体状态，使用相应模式。",
          "建议每日进行 10 分钟正念冥想，提升副交感神经活性，降低机体应激反应。",
          "优先保证睡眠时间与质量，充足的休息是身体修复的重要基础。",
        ],
      ],
      list2: {
        sleep: [
          [
            "在你最近一次的睡眠疗愈中，",
            "这些变化意味着身体进入了更深层的修复状态。",
            "建议持续使用安睡仪，以支持长期的睡眠恢复与副交感神经张力提升。",
          ],
          [
            "本次检测显示您的睡眠修复指标变化幅度较小。",
            "这并不代表疗愈无效，睡眠相关的神经调节往往需要连续积累。",
            "建议您继续坚持使用安睡仪，并在入睡前尝试缓慢的腹式呼吸，以增强整体修复效果。",
          ],
          [
            "本次睡眠疗愈中，您的修复相关指标尚未出现明显提升。",
            "在睡眠调节过程中，身体可能仍处于适应阶段。",
            "建议持续使用安睡仪，为神经系统提供稳定而温和的刺激，帮助逐步建立更有利于深度睡眠的生理节律。",
          ],
        ],
        relax: [
          [
            "在本次解压疗愈过程中，",
            "这说明您的神经系统正在有效抑制过激反应。",
            "建议在配合安睡仪使用的同时，加入延长呼气的呼吸节奏，以巩固放松效果。",
          ],
          [
            "本次解压疗愈显示压力相关指标变化幅度有限。",
            "这在压力较高或外界刺激频繁时较为常见，建议继续使用安睡仪，通过持续的迷走神经刺激，帮助身体逐步降低应激水平。",
            "",
          ],
          [
            "本次检测中，压力相关指标仍处于较高水平。",
            "在高压状态下，神经系统往往需要更连续的调节支持。",
            "建议坚持使用安睡仪进行解压疗愈，配合缓慢、延长呼气的呼吸方式，逐步帮助身体回到更平稳的状态。",
          ],
        ],

        soothe: [
          [
            "在最近一次舒缓疗愈后，",
            "这些变化意味着身心正在回归平衡状态。",
            "建议在坚持使用安睡仪的过程中，保持均匀而深长的腹式呼吸。",
          ],
          [
            "本次舒缓疗愈中，您的生理平衡相关指标变化不明显。",
            "舒缓与放松往往需要多次重复刺激来建立稳定效果，建议继续使用安睡仪，并配合深长、均匀的呼吸节奏。",
            "",
          ],
          [
            "本次结果显示，身心平衡相关指标仍有提升空间。",
            "在情绪或生理波动较大时，这是一个正常的过渡阶段。",
            "建议增加安睡仪的使用稳定性，并配合深长的腹式呼吸，持续为副交感神经提供支持，帮助状态逐步趋于平衡。",
          ],
        ],
        energize: [
          [
            "在本次活力模式疗愈中，您的生理指标展现出积极趋势。",
            "这表明您的神经系统具备良好的调节弹性。",
            "建议持续使用安睡仪，通过迷走神经刺激（VNS）帮助您更好地保持专注与执行力。",
          ],
          [
            "检测显示您的专注力相关指标波动较小。",
            "建议继续使用安睡仪，通过迷走神经刺激（VNS）帮助神经系统找回调节弹性，逐步恢复专注状态。",
            "",
          ],
          [
            "本次检测中，您的专注力相关指标暂时未出现明显改善。",
            "这在调节初期是较为常见的情况，神经系统的适应与恢复通常需要一定的连续刺激过程。",
            "建议您继续坚持使用安睡仪，通过迷走神经刺激（VNS）为神经系统提供稳定支持，逐步积累调节效果，帮助专注力与执行力稳步回升。",
          ],
        ],
      },
      AIList: [],
      // AI报告数据
      hrvDelta: 40.2, // 80.0 - 39.8
      hrDelta: 16, // 96 - 80

      // 详细指标对比数据
      metrics: [
        {
          name: "心率",
          helpId: 4,
          before: 0,
          after: 0,
          unit: "bpm",
          trendText: "",
          trendClass: "", // 绿色表示下降（好）向好good，正常normal，向坏bad
        },
        {
          name: "HRV",
          helpId: 2,
          before: 0,
          after: 0,
          unit: "ms",
          trendText: "",
          trendClass: "",
        },
        {
          name: "压力水平",
          helpId: 5,
          before: 0,
          after: 0,
          unit: "分",
          trendText: "",
          trendClass: "",
        },
        {
          name: "呼吸率",
          helpId: 3,
          before: 0,
          after: 0,
          unit: "次/分钟",
          trendText: "",
          trendClass: "",
        },
      ],
    };
  },

  computed: {
    listIndex() {
      let score = this.info.score;
      if (score == null) return 0;
      if (score < 60) return 3;
      if (score < 70) return 2;
      if (score < 80) return 1;
      return 0;
    },
  },
  mounted() {
    // this.$refs.HelpPop.open(5)
    this.getInfo();
  },
  methods: {
    async getInfo() {
      // this.$loading.open("加载中...");
      try {
        await report({ id: JSON.parse(localStorage.getItem("id")) }).then(
          (res) => {
            let info = res.baseInfo;
            this.info = info;
            this.aiSuggestion = res.aiSuggestion;
            let mode = info.mode;
            let modeTrendData = res.modeTrendData;

            // 指标映射配置（可扩展）
            let arr = [
              { beforeKey: "beforeBpm", afterKey: "afterBpm", type: "bpm" },
              { beforeKey: "beforeRMSSD", afterKey: "afterRMSSD", type: "hrv" },
              {
                beforeKey: "beforePressure",
                afterKey: "afterPressure",
                type: "pressure",
              },
              {
                beforeKey: "beforeBreathingRate",
                afterKey: "afterBreathingRate",
                type: "breathingRate",
              },
            ];
            arr.forEach((item, index) => {
              let before = info[item.beforeKey] || 0;
              let after = info[item.afterKey] || 0;

              this.metrics[index].before = before;
              this.metrics[index].after = after;
              this.metrics[index].trendText = modeTrendData[item.type].delta > 0 ? '+' + modeTrendData[item.type].delta : modeTrendData[item.type].delta;
              this.metrics[index].text = modeTrendData[item.type].trend;
              this.metrics[index].type = item.type;
              this.metrics[index].min = after - before;
              this.metrics[index].trendClass =
                modeTrendData[item.type].result || "bad";
            });

            if (res.aiSuggestion.result == "good") {
              this.AIList = this.list2[info.mode][0];
              let temArr = [
                this.metrics[1],
                this.metrics[0],
                this.metrics[2],
                this.metrics[3],
              ];
              let tem = temArr.filter((item) => {
                return item.trendClass === "good";
              });
              this.text = "";
              for (let i = 0; i < tem.length; i++) {
                //  modeTrendData[tem[i].type].trend +
                this.text =
                  this.text +
                  tem[i].name +
                  tem[i].text +
                  "了" +
                  `<span style="">${Math.abs(
                    Math.round(tem[i].min * 100) / 100
                  )}</span>` +
                  tem[i].unit +
                  "，";
                // color: red;
              }
              if (this.text) {
                this.text = this.text.slice(0, -1) + "。";
              }
            } else if (res.aiSuggestion.result == "normal") {
              this.AIList = this.list2[info.mode][1];
            } else if (res.aiSuggestion.result == "bad") {
              this.AIList = this.list2[info.mode][2];
            }
            console.log("重构数据", this.metrics, mode, this.AIList);
          }
        );
      } catch (err) {
        console.log('错误', err);
        this.$toast.error(err.msg);
      }
    },
    goBack() {
      this.$router.replace("/");
    },
    async _waitForResources(element) {
      await this.$nextTick();
      if (document.fonts?.ready) {
        await document.fonts.ready;
      }
      const images = element.querySelectorAll("img");
      if (images.length > 0) {
        await Promise.all(
          Array.from(images).map((img) => {
            if (img.complete && img.naturalHeight !== 0)
              return Promise.resolve();
            return new Promise((resolve) => {
              img.onload = resolve;
              img.onerror = resolve;
            });
          })
        );
      }
      await new Promise((resolve) => setTimeout(resolve, 150));
      element.offsetHeight;
    },
    async handleDownloadReport() {
      const el = this.$refs.cardRef;
      if (!el) return;
      await this._waitForResources(el);
      try {
        const dataUrl = await domtoimage.toPng(el, {
          bgcolor: "#ffffff",
          scale: 2,
          width: el.offsetWidth,
          height: el.offsetHeight,
          style: {
            transform: "none",
            margin: "0",
            padding: "3rem",
            position: "relative",
          },
        });
        // ==============================================
        // 👇 这一段是【手机保存到相册】的核心代码
        // ==============================================
        if (this.isMobile()) {
          // 手机端：保存到相册
          const link = document.createElement("a");
          link.href = dataUrl;
          link.download = `健康报告_${Date.now()}.png`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

        } else {
          // PC 端：正常下载
          const blob = await fetch(dataUrl).then((r) => r.blob());
          saveAs(blob, `健康报告_${Date.now()}.png`);
        }
      } catch (err) {
        console.error("生成失败", err);
      }
    },
    // 判断是否是手机端
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    handleRecapture() {
      localStorage.removeItem("mode");
      localStorage.removeItem("times");
      this.$router.replace("/IntendCollect");
    },
  },
};
</script>

<style lang="scss" scoped>
@media all and (min-width: 768px) {
  .health-report-page {
    min-height: 100vh;
    width: 100%;
    background: #fff;
    padding: 2rem;
    padding-top: 4rem;
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      sans-serif;
    margin: 0 auto;

    .cardRef {
      width: 75rem;
      margin: auto;
      padding: 3rem 0rem;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }

    .top-nav {
      width: 68.75rem;
      margin: 0 auto;
      margin-bottom: 2rem;

      .back-home {
        display: flex;
        align-items: center;
        color: #4e5361;
        font-size: 1.25rem;
        font-weight: 500;
        cursor: pointer;
        user-select: none;

        .back-icon {
          width: 1.625rem;
          height: 1.625rem;
          margin-right: 1.1rem;
        }
      }
    }

    .page-title {
      font-weight: bold;
      font-size: 3.5rem;
      color: #101424;
      text-align: center;
      margin-bottom: 1rem;
    }

    .disclaimer {
      font-size: 1.25rem;
      color: #666;
      text-align: center;
      margin-bottom: 2.5rem;
      line-height: 1.6;
      max-width: 70rem;
      margin-left: auto;
      margin-right: auto;
    }

    /* 顶部得分卡片 */
    .score-card {
      width: 68.75rem;
      margin: auto;
      background: linear-gradient(135deg, #66b3ff 0%, #0074fc 100%);
      border-radius: 1.25rem;
      padding: 2.5rem;
      text-align: center;
      margin-bottom: 1.5rem;
      color: #ffffff;

      .score-label {
        font-size: 1.125rem;
        margin-bottom: 1rem;
        opacity: 0.9;
      }

      .score-value {
        display: flex;
        align-items: baseline;
        justify-content: center;
        margin-bottom: 1rem;

        .score-number {
          font-size: 4rem;
          font-weight: bold;
          // margin-left: 3.5rem;
        }

        .score-unit {
          font-size: 1.5rem;
          margin-left: 0.5rem;
        }

        .info-icon {
          width: 1.25rem;
          height: 1.25rem;
          margin-left: 0.5rem;
          opacity: 0.8;
          cursor: pointer;
        }
      }

      .score-badge {
        display: inline-flex;
        align-items: center;
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid rgba(255, 255, 255, 0.3);
        border-radius: 2rem;
        padding: 0.5rem 1.25rem;
        font-size: 1.125rem;
        /* 核心：强制不换行 */
        white-space: nowrap !important;
        /* 防止文字被拆分换行（中文场景） */
        word-break: keep-all !important;

        .star-icon {
          width: 1rem;
          height: 1rem;
          margin-right: 0.5rem;
        }
      }
    }

    /* 详细指标对比卡片 */
    .comparison-card {
      width: 68.75rem;
      background: #ffffff;
      border-radius: 1.25rem;
      padding: 2rem;
      margin-bottom: 1.5rem;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

      .comparison-header {
        margin-bottom: 2rem;
        .comparison-title {
          font-size: 1.7rem;
          font-weight: bold;
          color: #101424;
          margin-bottom: 0.5rem;
          display: flex;
          align-items: center;
        }
        .comparison-subtitle {
          font-size: 1.2rem;
          color: #999;
        }
      }

      .metric-list {
        .metric-row {
          margin-bottom: 2.5rem;
          position: relative;

          &:last-child {
            margin-bottom: 0;
          }

          .metric-info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1rem;

            .metric-name {
              font-size: 1.5rem;
              font-weight: 500;
              color: #333;
              display: flex;
              align-items: center;
              gap: 0.5rem;

              /* 核心：强制不换行 */
              white-space: nowrap !important;
              /* 防止文字被拆分换行（中文场景） */
              word-break: keep-all !important;
              .info-icon-small {
                width: 1.5rem;
                height: 1.5rem;
                cursor: pointer;
              }
            }

            .metric-trend {
              font-size: 1.5rem;
              font-weight: 500;
              display: flex;
              align-items: center;
              gap: 0.2rem;

              .trend-icon {
                width: 1.5rem;
                height: 1.5rem;
                margin-right: 0.2rem;
              }
              &.good {
                color: #52c41a;
              }
              &.normal {
                color: #52c41a; /* 图片里心率下降也是绿色 */
              }
              &.bad {
                color: #999;
              }
            }
          }

          .metric-values {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 1rem;

            .value-box {
              flex: 1;
              padding: 1.5rem;
              border-radius: 0.75rem;
              text-align: left;
              border: 1px solid #e5e5e7;

              .box-label {
                font-size: 1.125rem;
                color: #101424;
                margin-bottom: 0.5rem;
              }

              .box-value {
                font-size: 1.5rem;
                font-weight: bold;
                margin-bottom: 0.2rem;
              }

              .box-unit {
                font-size: 1.125rem;
                color: #101424;
              }
            }

            .before-box {
              background: #fff;
              .box-value {
                color: #0074fc;
              }
            }

            .after-box {
              background: #f6ffed; /* 浅绿色背景 */
              border-color: #b7eb8f;
              .box-value {
                color: #52c41a;
              }
            }
            .after-box-no {
              background: #ffffff; /* 浅绿色背景 */
              border-color: rgba(0, 116, 252, 0.5);
              .box-value {
                color: #52c41a;
              }
            }

            .arrow-icon {
              width: 4rem;
              height: 4rem;
              margin: 0 5rem;
            }
          }
          .line {
            display: none;
          }
        }
      }
    }

    /* AI报告卡片 */
    .ai-report-card {
      width: 68.75rem;
      background: #ffffff;
      border-radius: 1.25rem;
      padding: 2rem;
      margin-bottom: 1.5rem;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

      .ai-title {
        font-size: 1.25rem;
        font-weight: bold;
        color: #101424;
        margin-bottom: 1.5rem;
      }

      .ai-content {
        font-size: 1.125rem;
        color: #666;
        line-height: 1.8;
        margin-bottom: 0.5rem;

        .highlight {
          color: #0074fc;
          font-weight: 500;
        }
      }
    }

    /* 个性化建议卡片 */
    .advice-card {
      width: 68.75rem;
      margin: 0 auto;
      background: linear-gradient(135deg, #66b3ff 0%, #0074fc 100%);
      border-radius: 1.25rem;
      padding: 2rem;
      margin-bottom: 1.5rem;
      color: #ffffff;

      .advice-title {
        font-size: 1.25rem;
        font-weight: 600;
        margin-bottom: 1rem;
      }

      .advice-disclaimer {
        font-size: 1.125rem;
        line-height: 1.6;
        opacity: 0.8;
        margin-bottom: 1.5rem;
      }

      .advice-list {
        .advice-item {
          display: flex;
          align-items: center;
          justify-content: left;
          // align-items: anchor-center;
          background: rgba(255, 255, 255, 0.15);
          border-radius: 0.5rem;
          padding: 1rem;
          margin-bottom: 0.75rem;
          font-size: 1.125rem;
          line-height: 1.6;

          /* 核心：强制不换行 */
          white-space: nowrap !important;
          /* 防止文字被拆分换行（中文场景） */
          word-break: keep-all !important;
          .advice-icon {
            width: 1.25rem;
            height: 1.25rem;
            margin-right: 0.75rem;
            flex-shrink: 0;
          }
        }
      }
    }

    .button-group {
      width: 68.75rem;
      margin: 0 auto;
      margin-bottom: 5rem;
      display: flex;
      gap: 1rem;

      .btn-download {
        flex: 1;
        height: 3.5rem;
        background: #0074fc;
        border: none;
        border-radius: 0.75rem;
        color: #ffffff;
        font-size: 1.125rem;
        font-weight: 500;
        cursor: pointer;
        transition: background 0.2s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;

        .download-icon {
          width: 1.25rem;
          height: 1.25rem;
        }

        &:hover {
          background: #0066e0;
        }

        &:active {
          background: #0058c0;
        }
      }

      .btn-recapture {
        flex: 1;
        height: 3.5rem;
        background: #e8f4ff;
        border: none;
        border-radius: 0.75rem;
        color: #0074fc;
        font-size: 1.125rem;
        font-weight: 500;
        cursor: pointer;
        transition: background 0.2s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;

        .refresh-icon {
          width: 1.25rem;
          height: 1.25rem;
        }

        &:hover {
          background: #d0e8ff;
        }

        &:active {
          background: #b8dcff;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .health-report-page {
    min-height: 100vh;
    width: 100%;
    background: #f5f6fe;
    padding-bottom: 2rem;
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      sans-serif;
    margin: 0 auto;

    .cardRef {
      width: 46.875rem;
      margin: auto;
      padding: 3rem 0rem 1.5rem;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }

    .top-nav {
      width: 42.375rem;
      margin: 0 auto;
      margin-bottom: 2rem;

      .back-home {
        width: 42.375rem;
        margin: auto;
        padding-top: 4rem;
        display: flex;
        align-items: center;
        color: #4e5361;
        font-weight: 600;
        font-size: 1.75rem;
        cursor: pointer;
        user-select: none;

        .back-icon {
          width: 2.25rem;
          height: 2.25rem;
          margin-right: 1.1rem;
          object-fit: contain;
        }
      }
    }
    .page-title {
      font-weight: bold;
      font-size: 3rem;
      color: #101424;
      text-align: center;
      margin-bottom: 1rem;
    }

    .disclaimer {
      font-size: 1.75rem;
      color: #666;
      text-align: center;
      margin-bottom: 2.5rem;
      line-height: 1.6;
      max-width: 70rem;
      margin-left: auto;
      margin-right: auto;
      padding: 0rem 2rem;
    }

    /* 顶部得分卡片 */
    .score-card {
      width: 42.375rem;
      margin: auto;
      background: linear-gradient(135deg, #66b3ff 0%, #0074fc 100%);
      border-radius: 1.5rem;
      padding: 5rem 2.5rem;
      text-align: center;
      margin-bottom: 1.5rem;
      color: #ffffff;

      .score-label {
        font-size: 2rem;
        margin-bottom: 1rem;
        opacity: 0.9;
      }

      .score-value {
        display: flex;
        // align-items: baseline;
        justify-content: center;
        height: 10rem;
        margin-bottom: 1rem;

        .score-number {
          font-size: 6.5rem;
          font-weight: bold;
          // margin-left: 6.5rem;
        }

        .score-unit {
          font-size: 2.5rem;
          margin-left: 0.5rem;
          line-height: 12.5rem;
        }

        .info-icon {
          width: 2.5rem;
          height: 2.5rem;
          margin-left: 0.8rem;
          margin-top: 5rem;
          cursor: pointer;
          opacity: 0.8;
        }
      }

      .score-badge {
        width: 26.25rem;
        height: 6.5rem;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid rgba(255, 255, 255, 0.3);
        border-radius: 6.4rem;
        padding: 0.5rem 1.25rem;
        font-size: 2rem;
        /* 核心：强制不换行 */
        white-space: nowrap !important;
        /* 防止文字被拆分换行（中文场景） */
        word-break: keep-all !important;

        .star-icon {
          width: 3.75rem;
          height: 3.75rem;
          margin-right: 0.5rem;
        }
      }
    }

    /* 详细指标对比卡片 */
    .comparison-card {
      width: 42.375rem;
      background: #ffffff;
      border-radius: 1.25rem;
      padding: 2rem;
      margin-bottom: 1.5rem;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

      .comparison-header {
        margin-bottom: 2rem;
        .comparison-title {
          font-size: 2rem;
          font-weight: bold;
          color: #101424;
          margin-bottom: 0.5rem;
          display: flex;
          align-items: center;
        }
        .comparison-subtitle {
          font-size: 1.75rem;
          color: #999;
        }
      }

      .metric-list {
        .metric-row {
          margin-bottom: 2.5rem;
          position: relative;

          &:last-child {
            margin-bottom: 0;
          }

          .metric-info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1rem;

            .metric-name {
              font-size: 1.9rem;
              font-weight: 500;
              color: #333;
              display: flex;
              align-items: center;
              gap: 0.5rem;
              /* 核心：强制不换行 */
              white-space: nowrap !important;
              /* 防止文字被拆分换行（中文场景） */
              word-break: keep-all !important;

              .info-icon-small {
                width: 2rem;
                height: 2rem;
                cursor: pointer;
                margin-left: 0.3rem;
              }
            }

            .metric-trend {
              font-size: 1.75rem;
              font-weight: 500;
              display: flex;
              align-items: center;
              gap: 0.2rem;

              .trend-icon {
                width: 2rem;
                height: 2rem;
                margin-right: 0.2rem;
              }
              &.good {
                color: #52c41a;
              }
              &.normal {
                color: #52c41a; /* 图片里心率下降也是绿色 */
              }
              &.bad {
                color: #999;
              }
            }
          }

          .metric-values {
            display: flex;
            align-items: center;
            justify-content: space-between;
            // gap: 1rem;

            .value-box {
              flex: 1;
              padding: 2rem;
              width: 15rem;
              box-sizing: border-box;
              border-radius: 1.5rem;
              text-align: left;
              border: 0.125rem solid rgba(0, 116, 252, 0.5);

              .box-label {
                font-size: 1.5rem;
                color: #666;
                margin-bottom: 0.5rem;
              }

              .box-value {
                font-size: 3.5rem;
                font-weight: bold;
                margin-bottom: 0.2rem;
              }

              .box-unit {
                font-size: 1.75rem;
                color: #999;
              }
            }

            .before-box {
              background: #fff;
              .box-value {
                color: #0074fc;
              }
            }

            .after-box {
              background: #f6ffed; /* 浅绿色背景 */
              border-color: #b7eb8f;
              .box-value {
                color: #52c41a;
              }
            }
            .after-box-no {
              background: #ffffff; /* 浅绿色背景 */
              border-color: rgba(0, 116, 252, 0.5);
              .box-value {
                color: #52c41a;
              }
            }

            .arrow-icon {
              width: 4rem;
              height: 4rem;
              margin: 0 2rem;
            }
          }

          .line {
            margin-top: 2.9rem;
            width: 37.875rem;
            height: 0.125rem;
            border-radius: 0px 0px 0px 0px;
            border: 0.125rem solid;
            opacity: 0.5;
            border-image: linear-gradient(
                90deg,
                rgba(0, 116, 252, 0),
                rgba(0, 116, 252, 1),
                rgba(0, 116, 252, 0)
              )
              2 2;
          }
        }
      }
      .metric-list .metric-row:last-child .line {
        display: none;
      }
    }

    /* AI报告卡片 */
    .ai-report-card {
      width: 42.375rem;
      background: #ffffff;
      border-radius: 1.5rem;
      padding: 2rem;
      margin-bottom: 1.5rem;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

      .ai-title {
        font-size: 2rem;
        font-weight: bold;
        color: #101424;
        margin-bottom: 1.5rem;
      }

      .ai-content {
        font-size: 1.75rem;
        color: #666;
        line-height: 1.8;
        margin-bottom: 0.5rem;

        .highlight {
          color: #0074fc;
          font-weight: 500;
        }
      }
    }

    /* 个性化建议卡片 */
    .advice-card {
      width: 42.375rem;
      margin: 0 auto;
      background: linear-gradient(135deg, #66b3ff 0%, #0074fc 100%);
      border-radius: 1.25rem;
      padding: 2rem;
      margin-bottom: 1.5rem;
      color: #ffffff;

      .advice-title {
        font-size: 2rem;
        font-weight: 600;
        margin-bottom: 1rem;
      }

      .advice-disclaimer {
        font-size: 1.5rem;
        line-height: 1.6;
        opacity: 0.8;
        margin-bottom: 1.5rem;
      }

      .advice-list {
        .advice-item {
          display: flex;
          align-items: anchor-center;
          background: rgba(255, 255, 255, 0.15);
          border-radius: 1.5rem;
          padding: 1.5rem;
          margin-bottom: 1.5rem;
          font-weight: 400;
          font-size: 2rem;
          color: #ffffff;
          line-height: 3.1875rem;

          .advice-icon {
            width: 3rem;
            height: 3rem;
            margin-right: 1rem;
            flex-shrink: 0;
          }
        }
      }
    }

    .button-group {
      width: 42.375rem;
      margin: 0 auto;
      margin-bottom: 5rem;
      display: flex;
      gap: 1rem;

      .btn-download {
        flex: 1;
        width: 20.5rem;
        height: 6.5rem;
        background: #0074fc;
        border: none;
        border-radius: 1.5rem;
        color: #ffffff;
        font-size: 2.25rem;
        font-weight: 500;
        cursor: pointer;
        transition: background 0.2s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;

        .download-icon {
          width: 3rem;
          height: 3rem;
        }

        &:hover {
          background: #0066e0;
        }

        &:active {
          background: #0058c0;
        }
      }

      .btn-recapture {
        flex: 1;
        width: 20.5rem;
        height: 6.5rem;
        background: #e8f4ff;
        border: none;
        border-radius: 1.5rem;
        color: #0074fc;
        font-size: 2.25rem;
        font-weight: 500;
        cursor: pointer;
        transition: background 0.2s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;

        .refresh-icon {
          width: 3rem;
          height: 3rem;
        }

        &:hover {
          background: #d0e8ff;
        }

        &:active {
          background: #b8dcff;
        }
      }
    }
  }
}
</style>